<div *ngIf="candidate">

  <!-- <div class="row align-items-center">

    <div class="col">
      <a class="link-arrow left" [scBackOnClick]>{{ texts.back | localize }}</a>
    </div>

    <div class="col-auto" *ngIf="project?.Type == 'Longlist'">
      <app-inline-candidate-status-dropdown [candidate]="candidate" [language]="loc.language"></app-inline-candidate-status-dropdown>
    </div>

  </div> -->

  <div class="row align-items-start">


    <div class="col col-shrink pl-4">

      <!-- <div class="mb-4">
        <div class="row">
          <div class="col-8">
            <app-candidate-base-project-item [assignment]="candidate.Assignment" [project]="project"></app-candidate-base-project-item>
          </div>
        </div>
      </div> -->

      <!-- <p class="mb-2" *ngIf="candidate.JobTitle">
        <i class="me-2 fa-sharp fa-solid fa-briefcase"></i>{{ candidate.JobTitle }}
      </p>
      <p class="mb-2" *ngIf="candidate.Company">
        <i class="me-2 fa-sharp fa-solid fa-building"></i>{{ candidate.Company }}
      </p> -->

      <p class="mb-2" *ngIf="candidate.City">
        <i class="me-2 fa-sharp fa-solid fa-location-dot"></i>{{ candidate.City }}
      </p>

      <p class="mb-2" *ngIf="candidate.XingUri">
        <fa class="fa-brands fa-square-xing me-2"></fa> <a [href]="candidate.XingUri" target="_blank">{{
          candidate.XingUri }}</a>
      </p>

      <p class="mb-2" *ngIf="candidate.LinkedInUri">
        <fa class="fa-brands fa-linkedin me-2"></fa> <a [href]="candidate.LinkedInUri" target="_blank">{{
          candidate.LinkedInUri }}</a>
      </p>

      <p class="mb-2" *ngIf="candidate.Phone">
        <i class="me-2 fa-sharp fa-solid fa-phone"></i>{{ candidate.Phone }}
      </p>
      <p class="mb-2" *ngIf="candidate.EMail">
        <a href="mailto:{{ candidate.EMail }}" class="text-primary">
          <i class="me-2 fa-sharp fa-solid fa-envelope"></i>{{ candidate.EMail }}
        </a>
      </p>
    </div>

    <div class="col-auto">
      <div class="avatar-container">
        <sc-avatar size="xl" [user]="candidate"></sc-avatar>
        <app-candidate-status-badge class="status-badge" *ngIf="candidate.Assignment"
          [assignment]="candidate.Assignment" [language]="loc.language"></app-candidate-status-badge>
      </div>
    </div>

    <div class="col-12">
      <hr>
    </div>
  </div>

  <div class="row mt-3" *ngIf="candidate.Intro">
    <div class="col-12">
      <div class="alert alert-primary mb-0 border">
        <div class="row">
          <div class="col-auto pe-0">
            <i class="fa-sharp fa-solid fa-stars text-primary"></i>
          </div>
          <div class="col">
            <p class="mb-0">{{ candidate.Intro }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>

<sc-modal #messageModal>
  <sc-modal-header>
    {{ texts.message | localize }}
  </sc-modal-header>
  <sc-modal-body>
    <div *ngIf="message">
      <div class="row align-items-center mb-2">
        <div class="col-12">
          <small>{{ texts.jobsiteLink | localize }}</small>
        </div>
        <div class="col">
          <input [ngModel]="message.JobsiteLink" readonly class="form-control" />
        </div>
        <div class="col-auto ps-0">
          <button class="btn btn-sm btn-secondary btn-circle" (click)="copyToClipboard(message.JobsiteLink, 'link')">
            <i *ngIf="!isCopied['link']" class="fa-sharp fa-solid fa-copy"></i>
            <i *ngIf="isCopied['link']" class="fa-sharp fa-solid fa-check"></i>
          </button>
        </div>
      </div>
      <div class="row align-items-center mb-2">
        <div class="col-12">
          <small>{{ texts.subject | localize }}</small>
        </div>
        <div class="col">
          <input [ngModel]="message.Subject" class="form-control" />
        </div>
        <div class="col-auto ps-0">
          <button class="btn btn-sm btn-secondary btn-circle" (click)="copyToClipboard(message.Subject, 'subject')">
            <i *ngIf="!isCopied['subject']" class="fa-sharp fa-solid fa-copy"></i>
            <i *ngIf="isCopied['subject']" class="fa-sharp fa-solid fa-check"></i>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <small>{{ texts.message | localize }}</small>
        </div>
        <div class="col">
          <textarea [ngModel]="message.Content" class="form-control" rows="10"></textarea>
        </div>
        <div class="col-auto ps-0">
          <button class="btn btn-sm btn-secondary btn-circle" (click)="copyToClipboard(message.Content, 'content')">
            <i *ngIf="!isCopied['content']" class="fa-sharp fa-solid fa-copy"></i>
            <i *ngIf="isCopied['content']" class="fa-sharp fa-solid fa-check"></i>
          </button>
        </div>
      </div>
    </div>
  </sc-modal-body>
  <sc-modal-footer>
    <button class="btn btn-secondary" (click)="messageModal.dismiss()">{{ texts.close | localize }}</button>
  </sc-modal-footer>
</sc-modal>